module.exports = __webpack_public_path__ + "static/media/playbook-mobiles-tiny.ef7f3a8d.jpg";